import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Nft from "../../Assets/Projects/NFT.png";
import Twins from "../../Assets/Projects/Twins.png";
import Cobs from "../../Assets/Projects/cobs.png";
import Pixmusic from "../../Assets/Projects/pixmusic.png";
import Chatbox from "../../Assets/Projects/chatbox.png";
import Pixbox from "../../Assets/Projects/pixbox.png";
import Pitstop from "../../Assets/Projects/pitstop.png";
import Darkpie from "../../Assets/Projects/darkpie.png";
import Sands from "../../Assets/Projects/sands.png";
import Todo from "../../Assets/Projects/Todo.png";
import Shop from "../../Assets/Projects/shop.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          <strong className="purple">Works</strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Pixmusic}
              title="Pixmusic"
              description="Music streaming platform react.js personal project."
              link="https://pixmusic.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Nft}
              title="Mightymongooses"
              description="Mighty Mongooses NFT (MME) project was inspired by the Bored Ape Yacht Club. Bored Apes Project created a big wave in the NFT world and we look to follow in their footsteps. Mighty Mongooses club is a community who strongly believes in a bright crypto future. Passion for NFTs connected our international team from Canada, Australia & Asia and resulted in the creation of 8,888 Mighty Mongooses."
              link="https://mightymongooses.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Cobs}
              title="Code2bsmart"
              description="Code2bsmart is an online community. we're committed to building E-learning and web experience"
              link="https://code2bsmart.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Pixbox}
              title="Pixmovies"
              description="My personal movie streaming platform. TMDB Api are used to fetch movie data. Material-ui libraries are used to create user interface"
              link="https://focused-perlman-cef731.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Shop}
              title="Twins products"
              description="Online shoping platform.react node.js project"
              link="https://twinsproducts.herokuapp.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Chatbox}
              title="Chatbox"
              description="Chatbox is a secure messaging platform. Chatengine.io api are used"
              link="https://rekhilalias.github.io/Chatbox-website"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Twins}
              title="Twins Garden"
              description="Twins Garden is the combination of home stay and agrotourism in kerala.
              we offering home food and accommodation facilities"
              link="https://twinsgardens.in"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Pitstop}
              title="CDI Pitstop Ui"
              description="
            react testing library and Jest to wrote some test cases.
            used jira and bitbucket"
              link="https://trafigura-pluto.test.afa-cdi.com/login"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Darkpie}
              title="Dark pie"
              description="Vs code theme extension created by rekhil alias paulose"
              link="https://marketplace.visualstudio.com/items?itemName=Code2bsmart.code2bsmart-darkpie"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Todo}
              title="List-to-do"
              description="To Do is a task management app to help you stay organized and manage your day-to-day"
              link="https://rekhilalias.github.io/Todo-app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Sands}
              title="SandS associate "
              description="S and S Associate is a civil engineering consultancy service providing firm in Koothattukulam founded by Mr Sunny Mathew He has been in the field more than 30 years"
              link="https://sandsassociates.netlify.app"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
